import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal, SectionHead } from "@/components/Reveal";
import { STATS } from "@/data/content";

function AnimatedNumber({ value }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return <span ref={ref} data-testid="animated-counter">{display}</span>;
}

export default function Stats() {
  return (
    <section id="chiffres" className="relative overflow-hidden border-y border-gold/15 bg-night-soft py-16 md:py-24" data-testid="stats-section">
      <div className="grain absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead eyebrow="Le club en chiffres" title="Une communauté qui grandit." align="center" />
        <div className="mt-14 grid grid-cols-2 gap-y-12 lg:grid-cols-4" data-testid="stats-grid">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1}>
              <div className="relative px-4 text-center" data-testid={`stat-${s.label}`}>
                <p className="font-heading text-5xl font-extrabold tracking-tight sm:text-6xl lg:text-7xl">
                  <span className="text-gold-grad"><AnimatedNumber value={s.value} /></span>
                  <span className="text-gold">{s.suffix}</span>
                </p>
                <span className="mx-auto mt-4 block h-px w-10 bg-gold/50" />
                <p className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground sm:text-sm">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
